module.exports = __webpack_public_path__ + "static/media/close_white.60ac97c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/close_white.svg
// module id = 1037
// module chunks = 36